export var FileInputCaptureEnum;
(function (FileInputCaptureEnum) {
    FileInputCaptureEnum["ENVIRONMENT"] = "environment";
    FileInputCaptureEnum["USER"] = "user";
})(FileInputCaptureEnum || (FileInputCaptureEnum = {}));
//# sourceMappingURL=FileInputCaptureEnum.js.map